import { warn, } from 'application/console';
import actionCounterProviderActions from 'actions/actionCounterProviderActions';
import { fetchPostMetadata, } from
  'providers/actionCounter/currentPostActionCounterProvider';


const { DATA_RECEIVED, } = actionCounterProviderActions.TYPES;


function getPostData(){
  return (dispatch, getState) => fetchPostMetadata()
    .then((state) => dispatch({
      type: DATA_RECEIVED,
      state,
    }))
    .catch(warn);
}


export const postMetadataActions = {
  fetchData: getPostData,
};



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/postMetadataActions.js